module.exports = __webpack_public_path__ + "img/dotx.afdc3be6.png";